module.exports = __webpack_public_path__ + "static/media/banner.e0f8f9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner.png
// module id = 40
// module chunks = 0